import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { rem, VStack } from '@bonusly/design-system';

import { Panel } from '../../../components/panel';
import { DirectReportEntity } from '../../../entities/user';
import { DirectReportMenu } from './direct-report-menu';

interface TeamPanelProps {
	directReports: DirectReportEntity[];
	isOpen: boolean;
	isSidebarExpanded: boolean;
	onClose: () => void;
}

export const TeamPanel: FC<TeamPanelProps> = ({ directReports, isOpen, isSidebarExpanded, onClose }) => {
	const { t } = useTranslation('navigation');

	return (
		<Panel
			isOpen={isOpen}
			onClose={onClose}
			isSidebarExpanded={isSidebarExpanded}
			title={t('teamMenu.title')}
			closeButtonLabel={t('teamMenu.closePanel')}
			width={rem(320)}
			data-testid="team-panel"
		>
			<VStack as="nav" aria-label={t('teamMenu.directReportsNavLabel')} gap={rem(4)} w="100%">
				{directReports.map((directReport) => (
					<DirectReportMenu key={directReport.id} directReport={directReport} />
				))}
			</VStack>
		</Panel>
	);
};
